import React from "react";
import styled from "@emotion/styled";
import {useTheme} from "@emotion/react";
import {useMobileDetect} from "../../../utils/Hooks";

export const FOOTER_TYPE_NONE = 1;
export const FOOTER_TYPE_BASE = 2;

const Footer = ({theme, container, footer}) => {
    const globalTheme = useTheme();
    const {is_mobile} = useMobileDetect();

    // css style
    const {view} = useComponentStyle();

    return footer.type !== FOOTER_TYPE_NONE && !is_mobile ? (
        <view.FooterContainer>
            <view.ContentWrapper>
                <view.FirstRowWrapper>
                    <view.EachItem color={globalTheme.colors.black} font_size={globalTheme.font_size.f15}>
                        문의
                    </view.EachItem>
                    <view.EachItem color={globalTheme.colors.black} font_size={globalTheme.font_size.f15}>
                        bear-u@tendom.co.kr 02-6958-9448
                    </view.EachItem>
                    <view.EachItem font_size={globalTheme.font_size.f14}>주중 10:00-18:00</view.EachItem>
                    <view.EachItem font_size={globalTheme.font_size.f15}>
                        <a href="https://bear-u.com/service/terms" target="_blank" rel="noreferrer">
                            <u>이용약관</u>
                        </a>
                    </view.EachItem>
                    <view.EachItem font_size={globalTheme.font_size.f15}>
                        <a href="https://new-dev.bear-u.com/service/privacy" target="_blank" rel="noreferrer">
                            <u>개인정보처리방침</u>
                        </a>
                    </view.EachItem>
                </view.FirstRowWrapper>
                <view.SecondRowWrapper>
                    <view.EachItem>
                        주식회사 텐덤&nbsp;&nbsp; 대표자 ・ 개인정보책임관리자&nbsp; 유원일 | 사업자번호 266-88-00335 |
                        통신판매업 신고번호 2016-서울마포-1971호 | 원격평생교육시설 신고 제2021-19호 | 서울 마포구
                        백범로 71,숨도빌딩 9층
                    </view.EachItem>
                </view.SecondRowWrapper>
                <view.ThirdRowWrapper>
                    <view.EachItem font_size={globalTheme.font_size.f15}>
                        ⓒ TENDOM Inc. All rights reserved.
                    </view.EachItem>
                </view.ThirdRowWrapper>
            </view.ContentWrapper>
        </view.FooterContainer>
    ) : null;
};

export default Footer;

export const useComponentStyle = () => {
    const theme = useTheme();
    return {
        view: {
            FooterContainer: styled.div({
                width: "100%",
                boxSizing: "border-box",
                borderTop: `1px solid ${theme.colors.dg3}`,
                display: "flex",
                justifyContent: "center",
                marginTop: "5em",
                padding: "1.5em 0",
            }),
            ContentWrapper: styled.div({
                width: "100%",
                maxWidth: "1128px",
                margin: "0 10px",
                height: "100%",
                color: theme.colors.dg2,
                display: "flex",
                flexDirection: "column",
            }),
            FirstRowWrapper: styled.div({
                width: "100%",
                display: "flex",
                alignItems: "end",
            }),
            EachItem: styled.span((props) => ({
                fontSize: props.font_size || "inherit",
                color: props.color || "inherit",
                marginRight: props.margin_right || ".5em",
                marginLeft: props.margin_left || "",
            })),
            SecondRowWrapper: styled.div({
                width: "100%",
                margin: "1em 0",
                fontWeight: "500",
                fontSize: theme.font_size.f14,
                display: "flex",
            }),
            ThirdRowWrapper: styled.div({
                width: "100%",
                fontSize: theme.font_size.f15,
                fontWeight: "500",
            }),
        },
    };
};
